import styled from 'styled-components';

export const Title = styled.h4`
    margin-top: 80px;
    margin-bottom: 50px;
    font-family: 'PoppinsSemiBold', 'NotoSanSemiBold';
`;